import { SET_DICTIONARY } from './constants';

export const setDictionary = dictionary => {
    return {
        type: SET_DICTIONARY,
        payload: dictionary,
    };
};
